import { Component, OnInit, isDevMode } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-veteran-military',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['../../step/step.component.scss','../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class VeteranMilitaryComponent extends ButtonStepComponent implements OnInit {
  title = "Are you or your spouse a veteran or active military?";
  buttonList = [
    { text: 'Yes', value: 'yes', imageName: 'yes' },
    { text: 'No', value: 'no', imageName: 'no-x', default: true},
  ];
  experiment: boolean;

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('veteranMilitary', this.control);
  }
  
  initStep() {
    // TODO: migrate/remove 'vwo_va_subtext' test
    setTimeout(() => this.experiment = false, 0);
  }
}
